import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { ExpertCard } from 'src/components/ExpertCard/ExpertCard'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { PremiumTag } from 'src/components/global/PremiumTag/PremiumTag'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { THEME } from 'src/config/config'
import { ISubTopicFullItemFragment, ITopicFullItemFragment } from 'src/graphql/generated/hooks'

import { FollowSubTopicButton } from '../global/FollowSubTopicButton'

interface TopicHeaderProps {
  className?: string
  topic: ITopicFullItemFragment | ISubTopicFullItemFragment
  subtopicButtonFlag?: boolean
}

/**
 * Primary UI component for user interaction
 */
export const TopicHeader: React.FC<TopicHeaderProps> = ({ className, topic, subtopicButtonFlag = false }) => {
  const expert = topic.attributes?.expert
  const isPremium = topic.attributes?.isPremium
  const [subTopic, setSubTopic] = useState({})

  // eslint-disable-next-line no-console

  useEffect(() => {
    setSubTopic(topic)
  }, [topic])
  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="px-5 md:pl-0 !max-w-[1100px] w-full flex flex-col md:flex-row items-center pt-2 pb-5 md:pb-0 topic-header">
        <div className="flex flex-row">
          <div className="flex-4 md:pr-[7.5rem] mb-[2.125rem]">
            <div className="flex flex-row items-center">
              <h1 className="pt-[0.5rem] pb-[0.625rem] text-[1.875rem] font-bold font-secondary text-darkgray">
                {topic.attributes?.name}
              </h1>
              <ThemeOnly theme="legaltech">
                {isPremium && <PremiumTag className="ml-[10px] text-[0.8125rem]" />}
              </ThemeOnly>
            </div>
            {topic.attributes?.description && (
              <h2 className="text-[0.9375rem] mb-[16px] font-primary font-regular text-darkgray">
                <HtmlContentViewer
                  contentClassName={cn('font-primary', {
                    '!font-tertiary !font-regular !text-topicDescription': THEME === 'ilta',
                  })}
                  html={topic.attributes?.description}
                />
              </h2>
            )}
            {subtopicButtonFlag && (
              <div className="subtopic-button">
                <FollowSubTopicButton
                  subTopic={subTopic}
                  id={''}
                  isButton={true}
                  displayName={null}
                  isEnhanced={false}
                  isFromSubTopic={true}
                />
              </div>
            )}
          </div>
        </div>
        <ThemeOnly theme="legaltech">{expert?.data && <ExpertCard expert={expert.data} />}</ThemeOnly>
      </div>
    </div>
  )
}
